import app from 'flarum/forum/app';
const requests = new Map();
export default function loadLinkPreview(url) {
  if (!requests.has(url)) {
    const request = app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/devconnect/link-preview?url=${encodeURIComponent(url)}`
    }).then(response => response?.data?.attributes || null).catch(() => null);
    requests.set(url, request);
  }
  return requests.get(url);
}
flarum.reg.add('devconnect-link-cards', 'forum/service/linkPreview', loadLinkPreview);
flarum.reg.add('devconnect-link-cards', 'forum/service/linkPreview', loadLinkPreview);